// поле экспорта для валюты, выделенной из значения вида "<сумма> <валюта>"
export const getCurrencyExportField = (field: string): string => `${field}Currency`;

// значение собирается на бэкенде как "<сумма> <валюта>" (например, "2661.00 EUR"); сумма может быть с запятой,
// т.к. форматируется текущей культурой сервера, поэтому приводим разделитель к точке.
// Если значение не похоже на сумму, возвращаем его как есть, чтобы ничего не потерять
export const splitAmountAndCurrency = (value: string | null | undefined): { amount: string; currency: string } => {
    const match = value?.match(/^\s*(-?\d+(?:[.,]\d+)?)\s*(.*?)\s*$/);

    if (!match) {
        return {amount: value ?? '', currency: ''};
    }

    return {amount: match[1].replace(',', '.'), currency: match[2]};
};
